<template>
    <transition name="slide">
        <div class="modal fade" tabindex="-1" role="dialog" :class="onaddnote ? 'show' : 'show'"
            :style="onaddnote ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4">
                            <i class="bi bi-card-checklist"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">Nota</h5>
                            <small class="d-block text-xs text-muted">Agregar nueva nota.</small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <textarea class="form-control from-control-sm" rows="10" v-model="data.note" :class="errors.note ? 'is-invalid' : ''"></textarea>
                        <small class="invalid-feedback" v-for="(error, index) in errors.note" :key="index">{{ error }}</small>
                    </div>
                    <div class="modal-footer">
                        <button @click="ADD(1)" type="button" class="btn btn-h btn-primary px-3">
                            <div class="spinner-border spinner-border-sm" role="status"
                                v-if="count == 1 && data.option == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Guardar</span>
                        </button>
                        <button @click="ADD(2)" type="button" class="btn btn-h btn-dark px-3">
                            <div class="spinner-border spinner-border-sm" role="status"
                                v-if="count == 1 && data.option == 2">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Guardar y noficar</span>
                        </button>
                        <button @click="$emit('onclose')" type="button"
                            class="btn btn-h btn-danger px-3">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    props: ['onaddnote'],
    data() {
        return {
            data: {
                option: 1,
                note: '',
            },
            errors: {},
            count: 0,
            id: this.$route.params.id,
        }
    },
    methods: {
        ADD: function (option) {
            let vue = this
            vue.data.option = option
            vue.count++
            vue.errors = {}
            if (vue.count == 1) {
                axios({ url: '/packages/notes/' + vue.id, method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$emit('onreload')
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
}
</script>